import angular from "angular";
import component from "./articles-control.component";

angular.module('articlesControl', [component]);

export default 'articlesControl';


// WEBPACK FOOTER //
// ./resources/assets/modules/articles-control/articles-control.module.js